<template>
  <div>
    <b-modal
      id="modal_daily_box"
      ref="modal_daily_box"
      modal-class="modal modal_daily_box fade"
      dialog-class="modal-dialog position-relative"
      header-class=""
      body-class=""
      footer-class="modal-footer justify-content-center border-top-0"
      hide-footer
    >
      <template v-slot:modal-header>
        <button type="button" class="close rounded-circle m-0" data-dismiss="modal" aria-label="Close" @click="$bvModal.hide('modal_daily_box')">
          <i class="icon-clear" />
        </button>
        <div class="daily_title">
          <img src="@/assets/theme4/img/modal_daily_box.png">
        </div>
      </template>
      <div class="daily_body">
        <div class="daily_outside_container">
          <div class="daily_container">
            <!-- daily_checked, daily_green, daily_yellow, daily_gray -->
            <div v-for="(item, key) in setting" :key="key" class="daily_box" :class="getStatusClass(item, key)" @click="clickJoinEvent(item, key)">
              <div v-if="getStatusClass(item, key) === 'daily_checked'" class="green_check">
                <img src="@/assets/theme4/img/modal_daily_check.png">
              </div>
              <img src="@/assets/theme4/img/modal_daily_coin.png">
              <p>{{ item.prize | numberFormat }}P</p>
              <div class="daily_note">
                need t.o {{ item.performance }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </b-modal>
  </div>
</template>

<script>
import { getEvent, getEventDetail, joinEventV2 } from '@/api/event'
import { showNotice } from '@/utils/tool'

export default {
  name: 'DailyBox',
  data() {
    return {
      event_id: 0,
      reward: {},
      setting: []
    }
  },
  created() {
    for (let i = 0; i < 20; i++) {
      this.setting[i] = {
        prize: ' - ',
        performance: ' - '
      }
    }
  },
  mounted() {
    this.$root.$on('bv::modal::show', async(bvEvent, modalId) => {
      if (modalId === 'modal_daily_box') {
        const res = await getEvent()
        for (const i in res.data.data.list) {
          if (res.data.data.list[i].type === 'signup_v3') {
            this.event_id = res.data.data.list[i].id
          }
        }
        this.goGetEventDetail()
      }
    })
  },
  methods: {
    getStatusClass(item, key) {
      // daily_checked, daily_green, daily_yellow, daily_gray
      if (key === this.reward.currentEventPrizeIndex) {
        // 可領取
        if (this.reward.rewards[key].prize === 0) {
          // 未領取
          return 'daily_green cursor-pointer'
        } else {
          // 已領取
          return 'daily_checked'
        }
      } else {
        if (key < this.reward.currentEventPrizeIndex) {
          if (this.reward.rewards[key].prize === 0) {
            return 'daily_gray'
          } else {
            return 'daily_checked'
          }
        }
        return 'daily_yellow'
      }
    },
    async goGetEventDetail() {
      const res = await getEventDetail(this.event_id)
      this.setting = res.data.data.setting
      this.reward = res.data.data.reward
    },
    clickJoinEvent(item, key) {
      if (key !== this.reward.currentEventPrizeIndex) return
      joinEventV2({
        event_id: this.event_id,
        day_index: key
      }).then(response => {
        // console.log(response)
        this.goGetEventDetail()
      }).catch(e => {
        console.log(e)
        if (e.response.data.msg === 'vip_level_not_allow_join_event') {
          showNotice(this.$t('Bao.DailyBox_11'))
        } else if (e.response.data.msg === 'member_level_not_allow_join_event') {
          showNotice(this.$t('Bao.DailyBox_12'))
        }
      })
    }
  }
}
</script>
